import 'css-chunk:src/app/containers/Home/ApplicationsView/ApplicationDetailView/ApplicationInstances.scss';export default {
  "ApplicationInstances": "_ApplicationInstances_m497x_1",
  "header": "_header_m497x_1",
  "uninstallButton": "_uninstallButton_m497x_7",
  "installButton": "_installButton_m497x_10",
  "table": "_table_m497x_13",
  "cell": "_cell_m497x_13"
};